const $ = window.$;
import store from '../store/index';
import {fixCardTableSortBtn,showSystemNoti} from '@/shared/helper'

var submitButton = null;
var submitButtonText = null;
const authData = store.getters["auth/getAuthData"];
$.ajaxSetup({
  headers: {
    'Authorization': `bearer ${(authData ? authData.token : '')}`
  }
});

function strip(html)
{
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}


function data_process(action, data)
{
  var obj;
  if (typeof action !== "undefined")
  {
    action = action.replace('/', '_');
    if (typeof window[action] === "function")
    {
      try
      {
        window[action](data);
      } catch (e)
      {
        //showSystemNoti('danger','خطای سرور');
      }
    }
    else
    {
      if (typeof data == "object")
        obj = data;
      else
        obj = JSON.parse(data);
      if (typeof obj.ok !== 'undefined' && (obj.message || obj.error))
      {
        if (obj.ok)
          obj.result = 'success';
        else
        {
          obj.result = 'danger';
          obj.message = obj.error;
        }

        showSystemNoti(obj.result, obj.message);
      }
    }
  }
  else
  {
    if (typeof data == "object")
      obj = data;
    else
      obj = JSON.parse(data);
    if (typeof obj.ok !== 'undefined' && (obj.message || obj.error))
    {
      if (obj.ok)
        obj.result = 'success';
      else
      {
        obj.result = 'danger';
        obj.message = obj.error;
      }
      showSystemNoti(obj.result, obj.message);
    }
  }
}


$(document).ready(function ()
{

  $('body').click(function (e){
    const container = $(".card-table table.table .sort-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
      $('.card-table table.table').removeClass('open');
    }
  })

  fixCardTableSortBtn();

  $(this).delegate('.card-table table.table .sort-btn', 'click', function ()
  {
    $(this).parent().toggleClass('open')
  });

  $(this).delegate('.card-table table.table thead th', 'click', function ()
  {
    const parent = $(this).parent().parent().parent();
    parent.removeClass('open');
    parent.find('.sort-btn strong').html($(this).text());
    setTimeout(function (){
      if(parent.find('.sorting_asc').length)
      {
        parent.find('.sort-btn').removeClass('desc').addClass('asc');
      }
      else
        parent.find('.sort-btn').removeClass('asc').addClass('desc');
    },600)
  });

  $(this).delegate(".ajax-form", 'submit', function (event)
  {
    event.preventDefault();
    submitButton = $(this).find("button[type='submit']");
    submitButtonText = strip(submitButton.html());
    submitButton.attr("disabled", true).html('<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>');
    var form = $(this);
    var url = form.attr("data-action");
    url = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + url;
    var responseFunction = form.attr('data-response');

    var data = new FormData();
    var formData = $(this).serializeArray();
    var n = formData.length;
    for (var i = 0; i < n; i++)
    {
      data.append(formData[i].name, formData[i].value);
    }

    var fileFlag = false;
    var forceModal = $(this).attr('data-force-modal');
    if (typeof forceModal !== undefined && forceModal === 'true')
      fileFlag = true;

    $.each($(this).find('input[type="file"]'), function (obj, v)
    {
      var file = v.files[0];
      fileFlag = true;
      var name = $(this).attr('name');
      data.append(name, file);
    });

    var modalCreated = false;
    $.ajax({
      xhr: function ()
      {
        var xhr = new window.XMLHttpRequest();

        if (fileFlag)
        {
          if (!modalCreated)
          {
            var html = '<div style="display: none;" class="modal fade" id="form_upload_modal" tabindex="-1" role="dialog" aria-labelledby="form_upload_modal" aria-hidden="true" data-backdrop="static" data-keyboard="false">\n' +
              '\t<div class="modal-dialog">\n' +
              '\t\t<div class="modal-content">\n' +
              '\t\t\t<div class="modal-header" align="center">\n' +
              '\t\t\t\t<h4 class="modal-title">درحال ارسال اطلاعات</h4>\n' +
              '\t\t\t</div>\n' +
              '\t\t\t<div class="modal-body" align="right">\n' +
              '\t\t\t</div>\n' +
              '\t\t\t\n' +
              '\t </div>\n' +
              '\t</div>\n' +
              '</div>';
            $('body').prepend(html);
            $('#form_upload_modal').modal('toggle');
            modalCreated = true;
          }
          xhr.upload.addEventListener("progress", function (evt)
          {
            if (evt.lengthComputable)
            {
              var percentComplete = (evt.loaded / evt.total) * 100;
              percentComplete = Math.round(percentComplete * 100) / 100;
              var html = ' <div class="progress">' +
                '<div class="progress-bar" role="progressbar" aria-valuenow="' + percentComplete + '" ' +
                'aria-valuemin="0" aria-valuemax="100" style="width:' + percentComplete + '%">' +
                '' + percentComplete + '%' +
                '</div>' +
                '</div> <br/><div style="text-align: center"><button type="button" class="btn btn-danger" onclick="abort_upload()">کنسل</button></div>';
              $('#form_upload_modal .modal-body').html(html);
            }
          }, false);
        }
        return xhr;
      },
      url: url,
      data: data,
      cache: false,
      contentType: false,
      processData: false,
      method: 'POST',
      success: function (data)
      {
        console.log(data)
        data_process(responseFunction, data, 0);
        if (fileFlag)
        {
          setTimeout(function ()
          {
            $('#form_upload_modal').modal('toggle');
          }, 500)
        }
        submitButton.attr("disabled", false).html(submitButtonText);
      },
      fail: function ()
      {
        showSystemNoti('danger', 'خطا در برقراری ارتباط با سرور');
        if (fileFlag)
          setTimeout(function ()
          {
            $('#form_upload_modal').modal('toggle');
          }, 1500);
        submitButton.attr("disabled", false).html(submitButtonText);
      },
      complete: function (xhr)
      {
        if (xhr.status !== 200)
        {
          // showSystemNoti('danger', 'درخواست مورد نظر معتبر نیست.');
          if (fileFlag)
          {
            setTimeout(function ()
            {
              $('#form_upload_modal').modal('toggle');
            }, 1500);
          }
          submitButton.attr("disabled", false).html(submitButtonText);
        }
        setTimeout(function ()
        {
          $('#form_upload_modal').remove();
        }, 1500);
      }
    });

  });
})


$(document).ready(function ()
{

  $(this).delegate('router-link', 'click', function ()
  {
    const to = $(this).attr('to');
    if (to)
    {
      // const params = $(this).attr('path') || null;
      // if (params)
      //   window.currentComponent.$router.push({ path: to ,params:params})
      // else
      window.currentComponent.$router.push({path: to})
    }
  })
  // function isScrolledIntoView(elem)
  // {
  //   var docViewTop = $(window).scrollTop();
  //   var docViewBottom = docViewTop + $(window).height();
  //
  //   var elemTop = $(elem).offset().top;
  //   var elemBottom = elemTop + $(elem).height();
  //
  //   return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  // }

  // $('#main-container').scroll(function ()
  // {
  //   $('.scroll-animation.animated').each(function ()
  //   {
  //     if (isScrolledIntoView(this) === true)
  //     {
  //       $(this).addClass($(this).data('animation'));
  //     }
  //   });
  // });
});



// --------------------- Category Page


$(document).ready(function ()
{
  // $(this).find('.search-items').each(function ()
  // {
  //   var lenght = $(this).find('li').length;
  //   if (lenght < 8)
  //     $(this).parent().find('.icon-input').css('display', 'none');
  // });
  $(this).delegate('.toggle-header','click',function ()
  {
    $(this).parent().find('.toggle-div').slideToggle();
    $(this).find('H6').toggleClass('h6');
  });

  $(this).delegate('.search-input',"keyup", function ()
  {
    var value = $(this).val().toLowerCase();
    $(this).parent().parent().find('.search-items li').filter(function ()
    {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    })
  });

});